import React from 'react';
import { Col, Row} from '../../components/RowCol';
import { Question } from '../Game/Game';
import Spacer from '../../components/Spacer';
import CategorySquare from '../../components/BigBoard/CategorySquare';
import TextEditor from '../../components/TextEditor';
import { EditFunction } from './GameEditor';
import QuestionEditor from './QuestionEditor';
import finalJeopardyImage from '../../images/final-jeopardy.jpg';
import styles from '../../style';
import BigQuestion from '../Game/BigQuestion';
import LocalFileStorage from '../../LocalFileStorage';

type Props = {
	category: string;
	question: Question;
	editRound: EditFunction;
	localFileStorage: LocalFileStorage;
};
type State = {
	preview: boolean;
};

class FinalJeopardyEditor extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {
			preview: false,
		};
	}

	editQuestion = () =>
		(
			editPath: (string | number)[],
			editType: 'edit' | 'insert_element' | 'delete_element' | 'delete_field',
			value?: string | number,
		) => {
			const { editRound } = this.props;
			editRound(
				(['question'] as (string | number)[]).concat(editPath),
				editType,
				value,
			);
		};

	render() {
		const { category, question, editRound, localFileStorage } = this.props;
		const { preview } = this.state;

		return (
			<Row>
				<Col>
					<Row alignCenter style={{
						position: 'relative',
					}}>
						<CategorySquare
							name={category}
						/>
						<Spacer horizontal={20} />
						<TextEditor
							placeholder="Category"
							text={category}
							edit={name => {
								editRound(
									['category'],
									'edit',
									name,
								);
							}}
						/>
					</Row>

					<Spacer vertical={15} />

					<Row alignCenter onClick={() => this.setState({ preview: true})}>
						<div
							style={{
								width: styles.squareWidth,
								height: styles.squareHeight,
								backgroundImage: `url(${finalJeopardyImage})`,
								backgroundPosition: 'center center',
								backgroundSize: 'contain',
								backgroundRepeat: 'no-repeat',
							}}
							className="hoverable"
						/>
						<Spacer horizontal={20} />
						<QuestionEditor
							question={question}
							edit={this.editQuestion()}
							allowDailyDouble={false}
							localFileStorage={localFileStorage}
						/>
					</Row>
				</Col>

				<Spacer horizontal={100} />

				{preview && (
					<div style={{
						width: '1020px',
						height: '829px',
					}}>
						<BigQuestion
							question={question}
							dailyDoubleWager={null}
							finalJeopardy={false}
							finalJeopardyWagers={null}
							localFileStorage={localFileStorage}
						/>
					</div>
				)}
			</Row>
		);
	}
}

export default FinalJeopardyEditor;
